import { render, staticRenderFns } from "./CreditsListItemCopy.vue?vue&type=template&id=03b876b7&scoped=true&"
import script from "./CreditsListItemCopy.vue?vue&type=script&lang=js&"
export * from "./CreditsListItemCopy.vue?vue&type=script&lang=js&"
import style0 from "./CreditsListItemCopy.vue?vue&type=style&index=0&id=03b876b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b876b7",
  null
  
)

export default component.exports